import Link from 'next/link';
import React, { useCallback } from 'react';
import { AppTheme } from '../../helper/enums';
import { useUser } from '../../lib/useUser';
import UserSignedInNN from './UserSignedInNN';

export type UserProps = {
  user: any
  setUser: any
}

export default function UserSignedIn(props: UserProps) {
  const [user] = useUser()

  const updateUser = useCallback((updatedUser: any) => {
    props.setUser(updatedUser)
  }, [props])

  return (<React.Fragment>
          {props.user && process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn
            ? <UserSignedInNN user={user} onLogout={() => { updateUser(null) }} />
            : <React.Fragment>
              <div className="user-login flex flex-col px-6 pt-10">
                <h2 className="font-lato truncate">{props.user.userEmail}</h2>
              </div>
              <div className="space-y-4 p-6 py-8">
                  <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserData&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
                    <a className="btn btn-primary w-full">Nutzerprofil</a>
                  </a>

                  <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserPass&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
                    <a className="btn btn-primary w-full">Passwort ändern</a>
                  </a>
                
                  <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserEmail&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
                    <a className="btn btn-primary w-full">Email ändern</a>
                  </a>
                  <hr/>
                  <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserDelete&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
                    <a className="btn btn-primary w-full">Account löschen</a>
                  </a>
              </div>
              <div className="p-6 py-8 border-t border-border">
                <Link href='#' onClick={(e) => { e.preventDefault(); updateUser(null) }} className="btn btn-light w-full">
                  {/* <a onClick={(e) => { e.preventDefault(); updateUser(null) }} className="btn btn-light w-full"> */}
                    Ausloggen
                    {/* </a> */}
                </Link>
              </div>
            </React.Fragment>
          }
      </React.Fragment>
  )
}